import { APPLICATION_AUTH_ROUTES, APPLICATION_PUBLIC_ROUTES } from "../routes";
import { ApplicationRouteProps } from "../routes/interfaces";

/**
 *
 * Utility function that checks the current page that the user is visiting
 * and returns the access type of the page, whether it is
 * publicly accessible (pages marked as "public" or "auth") or if it
 * requires the user to be logged in (pages marked as "protected").
 *
 * @returns A string that can be either "public" or "protected".
 *
 */
function handleCheckVisitedPageAccessType(): "public" | "protected" {
  const pathname: string = window.location.pathname;
  const ROUTES_TO_CHECK: ApplicationRouteProps[] = [
    ...APPLICATION_PUBLIC_ROUTES,
    ...APPLICATION_AUTH_ROUTES,
  ];

  // Extract only the paths from the defined routes
  const public_route_paths: string[] = ROUTES_TO_CHECK.map(
    (route: ApplicationRouteProps) => route.path,
  );

  // From these routes extract only the starting portion of the route
  // e.g. "/applications"
  const starting_public_route_paths: string[] = public_route_paths.map(path => {
    return "/" + path.split("/")[1];
  });

  // Avoid duplicates of these starting route paths
  const unique_public_route_paths: string[] = [...new Set(starting_public_route_paths)];

  // Check if the page on which the user is currently on is part
  // of these public or authentication routes or is it part of the
  // protected application that requires authentication
  return unique_public_route_paths.some(route => pathname.startsWith(route))
    ? "public"
    : "protected";
}

export default handleCheckVisitedPageAccessType;
